import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketAutomationReceivedRuleAllowedAction,
  ITicketAutomationReceivedRuleAllowedAction,
} from "../models/ticket-aut-rec-rule-allowed-action";

const TICKET_AUTOMATION_RECEIVED_RULE_ALLOWED_ACTION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleAllowedAction/";

export const createTicketAutomationReceivedRuleAllowedAction = (
  item: INewTicketAutomationReceivedRuleAllowedAction,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_ALLOWED_ACTION_ROUTE,
    item,
  );
};

export const getTicketAutomationReceivedRuleAllowedActionById = (
  id: string,
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleAllowedAction>(
    TICKET_AUTOMATION_RECEIVED_RULE_ALLOWED_ACTION_ROUTE + id,
  );
};

export const updateTicketAutomationReceivedRuleAllowedActionById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedRuleAllowedAction;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_ALLOWED_ACTION_ROUTE + id,
    item,
  );
};
